import { useCallback, useEffect, useState } from "react";
import { userApi } from "../services/api";

// PAGE_SIZE is 12; a household is a handful of people plus agents, but
// follow `next` anyway so a directory bigger than one page is never
// silently truncated. The cap is a runaway guard, not a real limit.
const MAX_PAGES = 20;

/**
 * Every active account on this mono — the assignee picker's source and the
 * lookup behind "who is this" badges. Returns { users, loading, error,
 * refresh }; users are sorted by username as the API returns them.
 */
const useHouseholdUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchUsers = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const all = [];
      let page = 1;
      for (;;) {
        const response = await userApi.household({ page });
        const data = response.data;
        all.push(...(Array.isArray(data) ? data : data?.results || []));
        if (!data?.next || page >= MAX_PAGES) break;
        page += 1;
      }
      setUsers(all);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  return { users, loading, error, refresh: fetchUsers };
};

export default useHouseholdUsers;
